<template>
<div class="">
<user-top></user-top>
<div class="millia">
<div class="ht tc mt50">修改密码</div>
<form class="layui-form" action="">
<ul class="userInfo">
<li><input type="password" name="old_password" lay-verify="title" placeholder="请输入原密码" class="layui-input" v-model="old_password"></li>
<li><input type="password" name="new_password" lay-verify="title" placeholder="请输入新密码" class="layui-input" v-model="new_password"></li>
<li><input type="password" name="confirm_password" lay-verify="title" placeholder="请重新输入新密码" class="layui-input" v-model="confirm_password"></li>
<li><button type="button" class="layui-btn layui-btn-lg layui-btn-normal" lay-submit @click="ChangePassWordEndter" lay-filter="ChangePassWordEndter">确认修改</button></li>
</ul>
</form>
</div>
</div>
</template>
<script>
import UserTop from '@/components/UserTop.vue'
export default {
    name: 'ChangePassWord',
    components: {
        UserTop
    },
    data () {
        return {
            old_password:"",
            new_password:"",
            confirm_password:"",
        }
    },
    mounted () {
        // layui.use('form', function(){
        //     var form = layui.form;
        // });
    },
    methods: {
        ChangePassWordEndter:function(){
            if(this.new_password==this.confirm_password){
                let url = "api/user/changePassword";
                let params = {
                    old_password:this.old_password,
                    new_password:this.new_password,
                    confirm_password:this.confirm_password

                }
                this.$ajax.post(url,params).then(function (response) {
                    if (response.data.status==1) {
                        layer.alert("密码修改成功");
                        this.$router.push('/UserInfo');
                    }else{
                        //layer.alert(response.data.info)
                        layer.alert("哎呦！出错了！")
                    }
                    if (response.data.status==-98) {
                        //alert(response.data.info);
                        this.$router.push('/');
                    }
                }.bind(this)).catch(function (err) {
                    console.log("连接失败");
                }.bind(this));
            }else{
               layer.alert("两次输入的密码不相同");
            }
        }
    }
}
</script>
<style scoped>



</style>